import { Component, type OnInit, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import type { NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

import { ActivateService } from "./activate.service";

@Component({
    selector: "app-activate",
    templateUrl: "./activate.component.html",
    standalone: false,
})
export class ActivateComponent implements OnInit {
    private activateService = inject(ActivateService);
    private route = inject(ActivatedRoute);

    error: string;
    success: string;
    modalRef: NgbModalRef;

    ngOnInit() {
        this.route.queryParams.subscribe((params) => {
            this.activateService.get(params["key"]).subscribe(
                () => {
                    this.error = null;
                    this.success = "OK";
                },
                () => {
                    this.success = null;
                    this.error = "ERROR";
                },
            );
        });
    }
}
